import ready from '../utils/ready';

const initializeAccordion = () => {
  // Toggle accordions
  document.querySelectorAll('.accordion__header').forEach((el) => {
    el.addEventListener('click', () => {
      el.parentElement?.classList.toggle('accordion__item--is-open');
    });
  });

  // Toggle footer accordions
  document.querySelectorAll('.footer__accordion-heading').forEach((el) => {
    el.addEventListener('click', () => {
      el.parentElement?.classList.toggle('footer__accordion--is-open');
    });
  });
};

ready(initializeAccordion);
